var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-service"},[_vm._v(" "+_vm._s(_vm.problemText)+" "),_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.CTAText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }